import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Barcode from "react-barcode";
import Loader from "../Loader/Loader";

import * as elementsActions from "../../redux/actions/elements";
import { detectPlatform } from "../../shared/utilities/common";
import { PLATFORMS } from "../../shared/constants/common";
import AddToGoogleWallet from "../AddToWallet/AddToGoogleWallet";
import AddToAppleWallet from "../AddToWallet/AddToAppleWallet";

// const clearIcon = require("./imgs/clear-icon.png");
const clearDarkIcon = require("./imgs/clear-dark-icon.svg");

class BarcodeWidget extends Component {
  handleCloseWidget = () => {
    const { onClose, toggleBarcodeCard } = this.props;
    if(onClose) {
      onClose();
    }
    toggleBarcodeCard({ showBarcodeCard: false, value: null});
  };

  renderAddToWallet = () => {
    const { platformWalletLoyaltyCardFeature } = this.props;
    if (!platformWalletLoyaltyCardFeature) {
      return null;
    }
    const platform = detectPlatform();
    if (platform === PLATFORMS.ANDROID || platform === PLATFORMS.WEB) {
      return <AddToGoogleWallet />;
    } if (platform === PLATFORMS.IOS) {
      return <AddToAppleWallet />;
    }
    return null;
  }

  render() {
    const { barcode } = this.props;
    return (
      <div
        className={`
    fixed inset-0 bg-opacity-25
    backdrop-blur-sm flex justify-center items-center
    zIndex
    bg-darkBlack
      ${!barcode?.showBarcodeCard ? "hidden" : ""}
    `}
      >
        <div
          className={`
          bg-white w-[343px] h-[346px] flex flex-col p-[20px] rounded-[40px]
           outline-none
        `}
        >
          <div
            className="w-full flex py-2 justify-center items-center border-b-[1px]"
            role="button"
            tabIndex={0}
            onKeyDown={this.handleCloseWidget}
            onClick={this.handleCloseWidget}
          >
            <p className="flex-1 text-center text-base leading-5 font-montserratMedium font-bold text-dark">Scan Barcode</p>
            <img
              src={clearDarkIcon}
              alt=""
              className="w-6 h-6 object-contain"
            />
          </div>
          <div className="relative flex items-center flex-col gap-4 w-full mx-auto h-full justify-center">
            { this.renderAddToWallet() }
            {barcode?.value ? (
              <Barcode value={barcode?.value} />
            ) : (
              <Loader className="w-16 h-16" />
            )}
          </div>
        </div>
      </div>
    );
  }
}

BarcodeWidget.propTypes = {
  onClose: PropTypes.func,
  toggleBarcodeCard: PropTypes.func,
  barcode: PropTypes.string,
  platformWalletLoyaltyCardFeature: PropTypes.bool,
}

BarcodeWidget.defaultProps = {
  onClose: null,
  toggleBarcodeCard: null,
  barcode: null,
  platformWalletLoyaltyCardFeature: false,
}

export const mapStateToProps = state => {
  return {
    barcode: state.elements.barcode,
    platformWalletLoyaltyCardFeature: state.loyalty.platformWalletLoyaltyCardFeature,
  };
};

export const mapDispatchToProps = dispatch => ({
  toggleBarcodeCard: value => dispatch(elementsActions.toggleBarcodeCard(value)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BarcodeWidget));
